// src/pages/GoalsPage.js

import React from "react";
import BackButton from "../components/BackButton";
import GoalsByMonth from "../components/GoalsByMonth";

export default function GoalsPage() {
  return (
    <div className="min-h-screen bg-blue-50">
      <header
        className="sticky top-0 left-0 right-0 z-30 bg-blue-50"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="mt-2 mx-auto px-4 flex items-center">
          <BackButton className="text-blue-600" ariaLabel="Back" />
          <div className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center">
            <h1 className="text-[20px] text-blue-800 dm-font font-black tracking-[-0.06em] leading-[0.9] select-none">
              Goals
            </h1>
          </div>
        </div>
      </header>

      <main className="bg-blue-50">
        <GoalsByMonth variant="inline" className="shadow-none border-none bg-blue-50 -mt-5" />
      </main>
    </div>
  );
}